export default __webpack_public_path__ + "static/media/480_dummy2016-fotograf03-de.36d94654.png";